import { render } from "./topup.vue?vue&type=template&id=1dc322b9&lang=html"
import script from "./topup.vue?vue&type=script&lang=js"
export * from "./topup.vue?vue&type=script&lang=js"

import "./topup.vue?vue&type=style&index=0&id=1dc322b9&lang=less"

import exportComponent from "/opt/nexus/frontend/v1/admin/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__